/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabels } from '@/wpt-lib/pdf/useData';
import { label } from '@/wpt-lib/utils/label';

const Strategy2027 = ({
    additionalDetails,
    ...props
}: Partial<{
    '2027Strategy': { [strategy: string]: boolean };
    additionalDetails: string;
}>) => {
    const strategies = useLabels('2027Strategy');
    return (
        <>
            <Row>
                <ListCell
                    label="Aligned UTS 2027 Strategic Initiatives"
                    values={Object.entries(props['2027Strategy'] ?? {})
                        .filter(([, s]) => s)
                        .map(([l]) => label(strategies, l))}
                />
            </Row>
            {additionalDetails && (
                <Row>
                    <ValueCell label="Aligned UTS 2027 Strategic Initiatives Details" value={additionalDetails} />
                </Row>
            )}
        </>
    );
};

export default Strategy2027;
